import { SocialFacebookIcon, SocialInstagramIcon, SocialLinkedInIcon, SocialXIcon } from '@motorway/mw-highway-code';

export const AUTHOR_SOCIAL_ICONS = [
  {
    domain: 'facebook.com',
    Icon: SocialFacebookIcon,
    title: 'Facebook',
  },
  {
    domain: 'instagram.com',
    Icon: SocialInstagramIcon,
    title: 'Instagram',
  },
  {
    domain: 'x.com',
    Icon: SocialXIcon,
    title: 'X',
  },
  {
    domain: 'linkedin.com',
    Icon: SocialLinkedInIcon,
    title: 'LinkedIn',
  },
];
